import { combineReducers } from 'redux';
import configPersist from './persistConfig';
import { connectRouter } from 'connected-react-router';

// Reducers
import { reducer as toastrReducer } from 'react-redux-toastr';
import { reducer as formReducer } from "redux-form";
import requirements from '../pages/form-requirements/reducer';
import signup from '../pages/auth/sign-up/reducer';
import home from '../pages/home/reducer';
import login from '../pages/auth/login/reducer';
import validation from '../pages/validation/reducer';


const persistLogin = configPersist('login', { whitelist: ['user', 'logged'] }, login);

export default (history) =>  combineReducers({
  signup,
  requirements,
  login: persistLogin,
  form: formReducer,
  home,
  validation,
  router: connectRouter(history),
  toastr: toastrReducer
});
